import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Tag, Timeline, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { getRootStore } from "@/stores/RootStore";
import { ORDER_STATUS_COLORS, ORDER_STATUS_LABELS, } from "@/types/order/order.common";
import styles from "@/styles/OrderDetail/StatusHistoryTimeline.module.less";
const { Text } = Typography;
const formatDateTime = (iso) => {
    if (!iso)
        return "—";
    return new Date(iso).toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};
const StatusHistoryTimeline = observer(() => {
    const { orderDetailStore } = getRootStore();
    const { statusHistory } = orderDetailStore;
    const items = statusHistory.map((entry) => {
        const label = entry.newStatus
            ? (ORDER_STATUS_LABELS[entry.newStatus] ?? entry.newStatus)
            : "—";
        const color = entry.newStatus
            ? (ORDER_STATUS_COLORS[entry.newStatus] ?? "default")
            : "default";
        return {
            key: entry.id,
            children: (_jsxs("div", { children: [_jsx("div", { className: styles.itemStatus, children: _jsx(Tag, { color: color, children: label }) }), _jsxs("div", { className: styles.itemMeta, children: [formatDateTime(entry.createdAt), entry.idTechnician ? ` · Техник: ${entry.idTechnician.slice(0, 8)}…` : ""] }), entry.reason ? (_jsxs("div", { className: styles.itemReason, children: ["\u041F\u0440\u0438\u0447\u0438\u043D\u0430: ", entry.reason] })) : null] })),
        };
    });
    return (_jsxs(Card, { className: styles.card, size: "small", children: [_jsx("div", { className: styles.sectionTitle, children: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u0432" }), items.length > 0 ? (_jsx(Timeline, { items: items })) : (_jsx(Text, { className: styles.emptyState, children: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u0432 \u043F\u0443\u0441\u0442\u0430" }))] }));
});
StatusHistoryTimeline.displayName = "StatusHistoryTimeline";
export default StatusHistoryTimeline;
